import { PlaycastGamepadState, Vector2 } from '@playcastdotio/CoreTypes';

export type PlaycastPlayerConnection = {
  id: string;
  player: {
    id: string;
    name: string;
    picture: string;
  };
  host: {
    id: string;
    description: string;
    authId: string;
  };
  timing: {
    active: boolean;
    started: number;
    ended: number;
  };
};

export type PlaycastPlayerModeOptions = {
  open: boolean;
};

export type PlayerPlaycastModeInputAccess = {
  gamepad: boolean;
  keyboard: boolean;
  mouse: boolean;
  touch: boolean;
  chat: boolean;
};

export type PlaycastPlayerMode = {
  mode: 'spectator' | 'player';
  useMobileGamepad: boolean;
  useGamepadAsMouse: boolean;
  locked: {
    screen: boolean;
    pointer: boolean;
    keyboard: boolean;
  };
};

export type PlaycastData = {
  gamepad: PlaycastGamepadState;
  video: {
    dimensions: Vector2;
  };
  mode: PlaycastPlayerMode;
  options: PlaycastPlayerModeOptions;
  device: {
    userAgent: string;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
  };
};

export const initialPlaycastData: PlaycastData = {
  gamepad: {
    playerCoordinates: {
      origin: 'topLeft',
      dimensions: { x: 0, y: 0 },
      display: { x: window.screen.width, y: window.screen.height },
    },
    gamepads: [],
  },
  mode: {
    mode: 'spectator',
    useMobileGamepad: false,
    useGamepadAsMouse: false,
    locked: {
      screen: false,
      pointer: false,
      keyboard: false,
    },
  },
  video: {
    dimensions: { x: 0, y: 0 },
  },
  options: {
    open: false,
  },
  device: {
    userAgent: '',
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  },
};
